import { Component, OnDestroy } from "@angular/core";
import { DesignService } from "src/app/design/design.service";
import { Design, DesignsEntity } from "src/app/design/design.model";
import { Subscription } from "rxjs";
import { MatSnackBar } from "@angular/material";
import { AuthService } from "src/app/auth.service";

@Component({
  selector: "app-new-system",
  templateUrl: "./new-system.component.html",
  styleUrls: ["./new-system.component.css"],
})
export class NewSystemComponent implements OnDestroy {
  private subscription$ = new Subscription();
  showLoader: boolean = true;
  designs: DesignsEntity[];

  searchDesign: string | number | any | null;

  constructor(
    private designService: DesignService,
    private snackBar: MatSnackBar,
    public auth: AuthService
  ) {}

  ngOnInit() {
    this.auth.userProfileSubject$.subscribe(
      (profile) => {
        if (profile) {
          this.getDesignList();
        }
      },
      (err) => {
        this.showLoader = false;
        this.snackBar.open(
          `Error in Getting Designer and Contractor Details`,
          "",
          {
            duration: 2000,
          }
        );
      }
    );
  }

  /**
   * Get Design List
   */
  getDesignList() {
    this.showLoader = true;
    this.subscription$.add(
      this.designService.getDesignList().subscribe(
        (result: Design) => {
          this.designs = result.Designs;
          this.showLoader = false;
        },
        (error) => {
          this.showLoader = false;
          this.snackBar.open(`Error in Getting Design List `, "", {
            duration: 2000,
          });
        }
      )
    );
  }

/**
 * unsubscribe the subscriptions
 */
  ngOnDestroy() {
    this.subscription$.unsubscribe();
  }
}
